'use client';

import React from 'react';

const WhyAIChangesChange = () => {
  return (
    <section className="py-24 lg:py-32 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold font-headline text-[#0A2540] mb-12 leading-tight">
            Why AI Changes the Nature of Change
          </h2>

          <div className="space-y-8 text-lg text-gray-800 font-body leading-relaxed">
            <div>
              <h3 className="text-2xl font-bold text-[#0A2540] mb-4">AI Evolves Continuously</h3>
              <p>
                Unlike traditional technology implementations with defined end states, AI capabilities advance continuously. Models improve, new applications emerge, and organisational use cases expand in real-time. Change is not a phase — it is a permanent condition.
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-[#0A2540] mb-4">AI Reshapes Multiple Dimensions Simultaneously</h3>
              <p>
                AI affects decisions, workflows, roles, and accountability at the same time. It requires changes to leadership behaviour, governance structures, operating models, and workforce capability — not sequentially, but concurrently.
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-[#0A2540] mb-4">Organisational Factors Outweigh Technical Barriers</h3>
              <p>
                Industry research consistently shows that most AI initiatives stall before scaling — not due to technical failure, but due to organisational and leadership factors. Readiness, alignment, governance, and adoption capability determine outcomes more than technology selection.
              </p>
            </div>

            <div className="mt-12 p-8 bg-white border-l-4 border-[#0A2540]">
              <p className="text-xl font-semibold text-gray-900">
                AI adoption creates ongoing change rather than one-off transformation. Organisations require a new discipline to lead this continuous evolution.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyAIChangesChange;